import { useContext } from 'react';
import { RouteProps } from 'react-router-dom';
import AuthContext from './AuthContext';

function PrivateRoute({ children }: RouteProps): JSX.Element {
  const auth = useContext(AuthContext);
  const isLoggedIn = auth.authenticated;

  if (!isLoggedIn) {
    localStorage.removeItem('isCheckIn');
    localStorage.removeItem('lastRunningTime');
  }

  return <>{isLoggedIn ? children : <>{auth.login()}</>}</>;
}

export default PrivateRoute;
